import React, { useCallback, useEffect } from 'react';
import { useGoogleReCaptcha } from 'react-google-recaptcha-v3';
import { useDispatch } from 'react-redux';
import {
  setReCaptchaToken,
  setIsValidReCaptcha,
} from '../../../redux/slices/reCaptchaSlice';
import Message from '../Message';
import { RECAPTCHA_NOT_VALID } from '../../../constants/texts';

const ReCAPTCHA = () => {
  const { executeRecaptcha } = useGoogleReCaptcha();
  const reduxDispatch = useDispatch();

  const handleReCaptchaVerify = useCallback(async () => {
    if (!executeRecaptcha) return;

    const token = await executeRecaptcha();
    reduxDispatch(setReCaptchaToken(token || ''));
    reduxDispatch(setIsValidReCaptcha(!!token));
  }, [executeRecaptcha]);

  useEffect(() => {
    if (executeRecaptcha) handleReCaptchaVerify();
  }, [executeRecaptcha, handleReCaptchaVerify]);

  return (
    <React.Fragment>
      {!executeRecaptcha && (
        <Message severity="error" message={RECAPTCHA_NOT_VALID} fullRounded />
      )}
    </React.Fragment>
  );
};

export default ReCAPTCHA;
